
/**
 * 应用类型
 *
 * @export
 * @interface App
 */
export interface App {
  /**
   * 应用名称
   */
  appName: string;
  /**
   * 应用code
   */
  appCode: string;
  /**
   * 星级
   */
  stars: number;
  /**
   * 应用访问地址
   */
  appUrl: string;
  /**
   * 应用字体名称
   */
  appFontName: string;
  /**
   * 应用字体颜色
   */
  appFontColor: string;
  /**
   * 应用字体大小
   */
  appFontSize: string;
  /**
   * 应用类型
   */
  appTypeID: number;
  /**
   * 显示方式：1#内嵌、2#外联
   */
  displayMode: 1 | 2;
}

/**
 * action类型枚举
 *
 * @export
 * @enum {number}
 */
export enum HomeActionTypes {
  // 获取应用列表
  FETCH_APP_LIST = "@@home/FETCH_APP_LIST",
  FETCH_APP_LIST_SUCCESS = "@@home/FETCH_APP_LIST_SUCCESS",
  FETCH_APP_LIST_ERROR = "@@home/FETCH_APP_LIST_ERROR",

  // 切换公司
  FETCH_SWITCH_COMPANY = "@@home/FETCH_SWITCH_COMPANY",
  FETCH_SWITCH_COMPANY_SUCCESS = "@@home/FETCH_SWITCH_COMPANY_SUCCESS",
  FETCH_SWITCH_COMPANY_ERROR = "@@home/FETCH_SWITCH_COMPANY_ERROR",

  // 获取个人认证信息
  FETCH_PERSONAL_CERT_INFO = "@@home/FETCH_PERSONAL_CERT_INFO",
  FETCH_PERSONAL_CERT_INFO_SUCCESS = "@@home/FETCH_PERSONAL_CERT_INFO_SUCCESS",
  FETCH_PERSONAL_CERT_INFO_ERROR = "@@home/FETCH_PERSONAL_CERT_INFO_ERROR",

  // 用户公司列表
  FETCH_PERSONAL_COMPANY_LIST = "@@home/FETCH_PERSONAL_COMPANY_LIST",
  FETCH_PERSONAL_COMPANY_LIST_SUCCESS = "@@home/FETCH_PERSONAL_COMPANY_LIST_SUCCESS",
  FETCH_PERSONAL_COMPANY_LIST_ERROR = "@@home/FETCH_PERSONAL_COMPANY_LIST_ERROR",

  /**更新home的state */
  UPDATE_HOME_STATE = "@@home/UPDATE_HOME_STATE"
}

export interface MyCompany {
  companyId: string;
  name: string;
  companyType: string;
  companyCertStatus: number;
  /**供应商类型 1803：商城供应商 */
  supplierType: string;
}

export interface MyCertInfo {
  userId: string;
  mobile: string;
  email: string;
  realName: string;
  nickName: string;
  picture: string;
  certStatus: string;
  companyId: string;
  companyName: string, // 公司名称
  companyType: string, // 公司类型:1#普通企业,2#代理机构 ,4#供应商
  companyCertStatus: number, // 公司实名认证状态 0:未实名，1:已实名,2:实名中
  companySize: number // 公司数量
  certNo: string;
  certType: string;
}


/**
 * Home state
 *
 * @export
 * @interface HomeState
 */
export interface HomeState {
  readonly appList: App[];
  readonly errors?: string;
  readonly loading: boolean;
  readonly myCertInfo?: MyCertInfo;
  readonly myCompanyList: MyCompany[];
  readonly loadingMyCompanyList: boolean;
  /**切换公司modal */
  readonly switchCompanyModal: boolean;
}
